// src/api_scripts/getCADvariable.js
import { fetchAllPages } from "../paginationUtils";

const getCADvariable = async (cadvariableName, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v2/cad-variable`;

  try {
    // Use the pagination utility to fetch all pages
    const cadvariablesArray = await fetchAllPages(relativeUri, accessToken, setProgress, "CAD Variables");
    console.log("Get Global Variables List API Response Data (all pages):", cadvariablesArray.length, "items");
    return cadvariablesArray;

  } catch (error) {
    console.error(`Error fetching CAD Variables:`, error);
    throw error; // Re-throw the error to be caught by the calling function
  }
};

export default getCADvariable;
